const KEY = "miq_campaign_attribution";

interface CampaignAttribution {
  timestamp?: number;
  location?: string | null;
  referrer?: string | null;
  utm_campaign?: string | null;
  utm_medium?: string | null;
  utm_source?: string | null;
}

let data: CampaignAttribution | null = null;

export const campaignAttributionWrite = (attrs: CampaignAttribution) => {
  try {
    data = attrs;
    localStorage.setItem(KEY, JSON.stringify(attrs));
    return true;
  } catch {
    return false;
  }
};

export const campaignAttributionAvailable = () => !!localStorage.getItem(KEY);

export const campaignAttributionRead = () => {
  if (data) {
    return { ...data };
  }

  try {
    const value = localStorage.getItem(KEY);

    if (!value) {
      return {};
    }

    const parsedValue = (JSON.parse(value) as CampaignAttribution) || {};
    data = parsedValue;

    return parsedValue;
  } catch {
    return {};
  }
};

export const campaignAttributionReadReferrerHostname = () => {
  const { referrer } = campaignAttributionRead();

  if (!referrer) {
    return undefined;
  }
  return new URL(referrer).hostname;
};

export const campaignAttributionHasSeoReferrer = () => {
  const hostname = campaignAttributionReadReferrerHostname();

  // Checks if the referrer is a search engine (SEO referrer)
  return (
    !!hostname &&
    /google|bing|duckduckgo|ecosia|yahoo|yandex|baidu/.test(hostname)
  );
};

interface Loc {
  href?: string;
  query: Record<string, string>;
}
export const campaignAttributionAggregate = (
  loc: Loc,
  ref: URL
): CampaignAttribution => {
  // Read utm query parameters
  const { utm_campaign, utm_medium, utm_source } = loc.query;

  return {
    timestamp: Date.now(),
    location: loc.href,
    referrer: ref ? ref.origin + ref.pathname : null,
    utm_campaign,
    utm_medium,
    utm_source,
  };
};
